<template>
  <section v-if="!item"></section>
  <section v-else-if="item.isPublic" class="topic-visibility">
    <div>
      Topic is <strong>public</strong> at this moment. This means that <u>any user</u> can find it and join it as an
      annotator.
    </div>
    <yn-button variant="contained" color="primary" title="Delete this topic" @click="change(false)"
      >Make private</yn-button
    >
  </section>
  <section v-else-if="!item.isPublic" class="topic-visibility">
    <div>
      Topic is <strong>private</strong> at this moment. This means that administrator(s) should manually add each
      annotator.
    </div>
    <yn-button variant="contained" color="primary" title="Delete this topic" @click="change(true)"
      >Make public
    </yn-button>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Button from '@/components/common/Button';

export default {
  components: {
    'yn-button': Button
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      item: s => s.topics.item
    })
  },
  methods: {
    async change(isPublic) {
      const lock = this.$lock();
      try {
        await this.$store.dispatch('topics/changeVisibility', { id: this.id, isPublic });

        this.$toast.success({
          title: 'Visibility changed',
          message: isPublic ? `Topic visibility changed to public.` : `Topic visibility changed to private.`
        });
      } catch (e) {
        this.$toast.error({
          title: 'Visibility change failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.topic-visibility {
  > div {
    margin-bottom: 1rem;
  }
}
</style>
